module.exports = __webpack_public_path__ + "static/img/4.bfcad20f.png";